<template>
  <div class="animate-fade-in font-sans">
    
    <section class="relative bg-carpatina-gri py-24 lg:py-32 px-4 overflow-hidden">
      
      <div class="absolute inset-0 z-0">
        <img src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2070&auto=format&fit=crop" 
             class="w-full h-full object-cover opacity-20 grayscale" 
             alt="Background Constructii">
        <div class="absolute inset-0 bg-gradient-to-r from-carpatina-gri via-carpatina-gri/90 to-carpatina-gri/40"></div>
      </div>

      <div class="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-12 relative z-10">
        <div class="md:w-3/5 text-white animate-slide-right">
          <div class="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-1.5 rounded-full border border-white/20 mb-6">
             <span class="w-2 h-2 rounded-full bg-carpatina-portocaliu animate-pulse"></span>
             <span class="text-[10px] font-bold uppercase tracking-widest">Lider în Teleorman</span>
          </div>

          <h1 class="text-5xl md:text-7xl font-black uppercase mb-6 leading-[0.9] tracking-tighter drop-shadow-lg">
            Construiește <br>
            <span class="text-transparent bg-clip-text bg-gradient-to-r from-carpatina-portocaliu to-orange-300 italic">Durabil</span>
          </h1>
          
          <p class="text-lg md:text-xl text-gray-300 leading-relaxed mb-10 max-w-xl font-medium border-l-4 border-carpatina-portocaliu pl-6">
            De la fundație până la acoperiș, îți livrăm materialele direct pe șantier. Stocuri reale, prețuri de producător și consultanță tehnică gratuită.
          </p>
          
          <div class="flex flex-wrap gap-4">
            <router-link to="/produse" class="bg-carpatina-portocaliu hover:bg-white hover:text-carpatina-gri text-white px-8 py-4 rounded-2xl font-black text-sm md:text-base shadow-[0_10px_40px_-10px_rgba(249,115,22,0.5)] hover:shadow-xl transition-all uppercase tracking-widest transform hover:-translate-y-1">
              Vezi Catalogul
            </router-link>
            <router-link to="/cerere-oferta" class="group flex items-center gap-2 border-2 border-white/30 text-white px-8 py-4 rounded-2xl font-black text-sm md:text-base hover:bg-white hover:border-white hover:text-carpatina-gri transition-all uppercase tracking-widest">
              Cere Ofertă <ArrowRight :size="18" class="group-hover:translate-x-1 transition-transform" />
            </router-link>
          </div>
        </div>

        <div class="md:w-2/5 hidden md:block relative animate-float">
           <div class="absolute inset-0 bg-carpatina-portocaliu/20 blur-[100px] rounded-full"></div>
           <img src="@/assets/homepage.jpg" 
                class="relative rounded-[3rem] border-8 border-white/10 shadow-2xl rotate-3 hover:rotate-0 transition duration-700 ease-out z-10" alt="Constructii">
        </div>
      </div>
    </section>

    <div class="bg-carpatina-verde text-white py-8 relative z-20 -mt-8 mx-4 md:mx-0 md:rounded-none rounded-2xl shadow-xl">
        <div class="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-6 divide-y md:divide-y-0 md:divide-x divide-white/20">
            <div class="flex items-center justify-center gap-4 py-2">
                <Truck :size="32" class="text-carpatina-portocaliu" />
                <div>
                    <h4 class="font-black uppercase text-sm">Livrare Rapidă</h4>
                    <p class="text-xs opacity-80">Flotă proprie în tot județul</p>
                </div>
            </div>
            <div class="flex items-center justify-center gap-4 py-2">
                <ShieldCheck :size="32" class="text-carpatina-portocaliu" />
                <div>
                    <h4 class="font-black uppercase text-sm">Calitate Garantată</h4>
                    <p class="text-xs opacity-80">Produse certificate ISO</p>
                </div>
            </div>
            <div class="flex items-center justify-center gap-4 py-2">
                <Wallet :size="32" class="text-carpatina-portocaliu" />
                <div>
                    <h4 class="font-black uppercase text-sm">Preț Corect</h4>
                    <p class="text-xs opacity-80">Direct de la producător</p>
                </div>
            </div>
        </div>
    </div>

    <section class="max-w-7xl mx-auto px-4 py-24" v-if="mainPromos.length > 0">
      <div class="flex flex-col md:flex-row justify-between items-end mb-12 gap-4 border-b border-gray-100 pb-6">
        <div>
           <span class="text-carpatina-portocaliu font-black uppercase text-xs tracking-widest mb-2 block">Top Vânzări</span>
           <h2 class="text-4xl font-black text-carpatina-gri uppercase tracking-tighter">
             Produsele <span class="text-carpatina-verde">Săptămânii</span>
           </h2>
        </div>
        <router-link to="/produse" class="group bg-gray-50 hover:bg-carpatina-gri hover:text-white px-6 py-3 rounded-xl font-bold uppercase text-xs transition-all flex items-center gap-2 text-carpatina-gri">
          Vezi tot catalogul <ArrowRight :size="16" class="group-hover:translate-x-1 transition-transform" />
        </router-link>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div v-for="p in mainPromos" :key="p.id" 
             class="bg-white rounded-[2rem] shadow-lg overflow-hidden border border-gray-100 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 group flex flex-col h-full">
          
          <div class="h-56 bg-gray-100 relative overflow-hidden">
             <img :src="'https://carpatinaprodcom.ro/api' + p.poze[0]?.url" 
                  v-if="p.poze.length"
                  class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700">
             <div v-else class="w-full h-full flex flex-col items-center justify-center text-gray-300 bg-gray-50">
                <ImageOff :size="32" />
                <span class="text-[10px] font-bold uppercase mt-2">Fără foto</span>
             </div>
             
             <div v-if="p.pret" class="absolute bottom-4 right-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-xl shadow-lg font-black text-carpatina-verde text-sm border border-gray-100">
               {{ p.pret }} <span class="text-[10px] text-gray-400">RON</span>
             </div>
          </div>

          <div class="p-6 flex flex-col flex-1">
            <h3 class="font-black text-carpatina-gri uppercase text-sm mb-2 line-clamp-2 leading-tight group-hover:text-carpatina-portocaliu transition-colors" :title="p.nume">
              {{ p.nume }}
            </h3>
            <div 
              class="text-xs text-gray-400 font-bold italic mb-2 line-clamp-2 flex-1" 
              v-html="p.detalii">
            </div>
            <router-link :to="'/produs/' + p.id" class="w-full text-center bg-gray-50 text-carpatina-gri border-2 border-transparent font-black py-3 rounded-xl hover:bg-white hover:border-carpatina-verde hover:text-carpatina-verde transition uppercase text-[10px] tracking-widest shadow-sm">
              Vezi Detalii
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-gray-50 py-24 px-4 relative overflow-hidden" v-if="extraPromos.length > 0">
      <div class="absolute top-0 right-0 opacity-5 pointer-events-none">
          <LayoutGrid :size="400" />
      </div>

      <div class="max-w-7xl mx-auto relative z-10">
        <div class="text-center mb-16">
          <h2 class="text-4xl font-black text-carpatina-verde uppercase tracking-tighter mb-4">Noutăți în Stoc</h2>
          <div class="h-1.5 w-24 bg-carpatina-portocaliu mx-auto rounded-full"></div>
        </div>
        
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div v-for="p in extraPromos" :key="p.id" 
               class="bg-white rounded-[2.5rem] shadow-sm hover:shadow-2xl transition-all duration-300 group flex flex-col h-full hover:-translate-y-2 border-b-8 border-transparent hover:border-carpatina-portocaliu">
             
             <div class="h-48 bg-white relative overflow-hidden rounded-t-[2.5rem] mx-2 mt-2">
                <img :src="'https://carpatinaprodcom.ro/api' + p.poze[0]?.url" 
                     v-if="p.poze.length"
                     class="w-full h-full object-cover rounded-[2rem] group-hover:scale-105 transition-transform duration-500">
                <div v-else class="w-full h-full flex flex-col items-center justify-center text-gray-300 bg-gray-100 rounded-[2rem]">
                   <ImageOff :size="24" />
                </div>
             </div>

             <div class="p-6 text-center">
               <h3 class="font-black uppercase text-sm text-carpatina-gri group-hover:text-carpatina-portocaliu transition-colors mb-2 line-clamp-1">{{ p.nume }}</h3>
               <div v-if="p.pret" class="text-carpatina-verde font-black text-lg italic mb-4">
                 {{ p.pret }} RON
               </div>
               <div v-else class="text-gray-400 font-bold text-xs uppercase mb-4 italic">Cere preț</div>
               
               <router-link :to="'/produs/' + p.id" class="inline-block bg-carpatina-bg px-6 py-2 rounded-full text-[10px] font-black uppercase text-carpatina-verde hover:bg-carpatina-verde hover:text-white transition">
                  Detalii Produs
               </router-link>
             </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-white py-24 px-4">
      <div class="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        
        <div class="space-y-10">
          <div>
            <div class="inline-block bg-orange-50 text-carpatina-portocaliu px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-widest mb-4">
                Program: Luni - Sâmbătă 08:00 - 18:00
            </div>
            <h2 class="text-4xl md:text-5xl font-black text-carpatina-gri uppercase tracking-tighter mb-4">
                Vino la <span class="text-carpatina-portocaliu underline decoration-4 underline-offset-4 decoration-carpatina-verde">depozit</span>
            </h2>
            <p class="text-gray-400 font-bold italic text-sm leading-relaxed max-w-md">
                Discută direct cu experții noștri. Te ajutăm să calculezi necesarul de materiale și să organizezi transportul.
            </p>
          </div>

          <div class="space-y-6">
            <div class="flex items-center gap-6 bg-white p-6 rounded-3xl border border-gray-100 shadow-xl hover:shadow-2xl transition-shadow group">
               <div class="bg-green-50 p-4 rounded-2xl text-carpatina-verde group-hover:bg-carpatina-verde group-hover:text-white transition-colors">
                  <MapPin :size="32" />
               </div>
               <div>
                 <p class="text-[10px] font-black uppercase text-gray-400 tracking-widest mb-1">Locație</p>
                 <p class="font-bold text-lg text-carpatina-gri">Strada Stadionului NR 14, Turnu Magurele</p>
               </div>
            </div>

            <div class="flex items-center gap-6 bg-white p-6 rounded-3xl border border-gray-100 shadow-xl hover:shadow-2xl transition-shadow group">
               <div class="bg-orange-50 p-4 rounded-2xl text-carpatina-portocaliu group-hover:bg-carpatina-portocaliu group-hover:text-white transition-colors">
                  <PhoneCall :size="32" />
               </div>
               <div>
                 <p class="text-[10px] font-black uppercase text-gray-400 tracking-widest mb-1">Comenzi Telefonice</p>
                 <a href="tel:0700000000" class="font-bold text-lg text-carpatina-gri hover:text-carpatina-portocaliu transition">0247 412 068</a>
               </div>
            </div>
          </div>
        </div>

        <div class="h-[500px] rounded-[3rem] overflow-hidden shadow-2xl border-4 border-white ring-1 ring-gray-100 relative group">
          <div class="absolute inset-0 bg-carpatina-verde/0 group-hover:bg-carpatina-verde/10 pointer-events-none transition-colors z-10"></div>
          
<iframe 
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2890.344446452285!2d24.8694086!3d43.7449557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40adb1ad68df6dfb%3A0x7bac47f3b96587e2!2sCARPATINA%20PRODCOM%20SRL!5e0!3m2!1sro!2sro!4v1709999999999!5m2!1sro!2sro" 
  width="100%" 
  height="100%" 
  style="border:0;" 
  allowfullscreen="" 
  loading="lazy"
  referrerpolicy="no-referrer-when-downgrade"
  class="grayscale group-hover:grayscale-0 transition-all duration-700">
</iframe>
        </div>

      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { 
  ArrowRight, ShieldCheck, Wallet, Truck, MapPin, PhoneCall, LayoutGrid, ImageOff
} from 'lucide-vue-next';

const produsePromovate = ref([]);

// Împărțim lista de produse în două: primele 4 și următoarele 4
const mainPromos = computed(() => produsePromovate.value.slice(0, 4));
const extraPromos = computed(() => produsePromovate.value.slice(4, 8));

onMounted(async () => {
  document.title = "Carpatina Prodcom | Depozit Materiale de Construcții Turnu Măgurele";
  
  // Adăugare Meta Description pentru Google
  const metaDescription = document.querySelector('meta[name="description"]') 
                          || document.createElement('meta');
  metaDescription.name = "description";
  metaDescription.content = "Depozitul tău de încredere în Teleorman. Oferim materiale de construcții de înaltă calitate, livrare rapidă din stoc propriu și prețuri competitive direct de la producător.";
  if (!document.querySelector('meta[name="description"]')) {
    document.head.appendChild(metaDescription);
  }

  try {
    // Backend-ul returnează 8 produse (limit=8)
    const res = await axios.get('/produse/promovate');
    produsePromovate.value = res.data;
  } catch (err) {
    console.error("Nu am putut încărca ofertele", err);
  }
});
</script>

<style scoped>
.animate-fade-in { animation: fadeIn 0.8s ease-out; }
.animate-slide-right { animation: slideRight 1s ease-out; }

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideRight { 
    from { opacity: 0; transform: translateX(-30px); } 
    to { opacity: 1; transform: translateX(0); } 
}

.animate-float { animation: float 6s ease-in-out infinite; }
@keyframes float {
    0% { transform: translateY(0px) rotate(3deg); }
    50% { transform: translateY(-15px) rotate(0deg); }
    100% { transform: translateY(0px) rotate(3deg); }
}
</style>